"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var doubleMetricCard_styles_1 = require("./doubleMetricCard.styles");
var singleMetricCard_1 = require("../single-metric/singleMetricCard");
var core_components_1 = require("@securityproducts/core-components");
var doubleMetricCard_i18n_1 = require("./doubleMetricCard.i18n");
function DoubleMetricCard(props) {
    var strings = core_components_1.useLocalisation(doubleMetricCard_i18n_1.doubleMetricCardTranslations, props.language);
    return (React.createElement("div", { className: doubleMetricCard_styles_1.doubleContainer },
        React.createElement("div", { className: doubleMetricCard_styles_1.card, id: "total-calls" },
            React.createElement(singleMetricCard_1.SingleMetricCard, { id: "total-calls", title: strings.totalCalls, value: core_components_1.delimited({ value: props.totalCalls }) })),
        React.createElement("div", { className: doubleMetricCard_styles_1.card, id: "rolled-calls" },
            React.createElement(singleMetricCard_1.SingleMetricCard, { id: "rolled-calls", title: strings.rolledCalls, value: core_components_1.delimited({ value: props.rolledCalls }) }))));
}
exports.DoubleMetricCard = DoubleMetricCard;
